<div class="login-container">
  <form
    [formGroup]="forgotPasswordConfirmForm"
    class="login-form flex flex-col mb-16"
    (submit)="onConfirmForgotPasswordSubmit()"
  >
    @switch (state) {
      @case (ForgetPassword.RESET_PASSWORD) {
        <div class="flex flex-col flex-1 justify-center">
          <div class="title-l mb-24">
            {{ 'RESET_PASSWORD' | translate }}
          </div>
          @if (!token) {
            <div class="flex flex-col mb-12">
              <label class="title-s cl-on-background mb-8" for="confirm_pass">{{
                  'OLD_PASSWORD' | translate
                }}</label>
              <nz-input-group
                [nzPrefix]="passwordPrefix"
                [nzSuffix]="oldPassword"
              >
                <input
                  id="old_pass"
                  formControlName="oldPassword"
                  nz-input
                  nzSize="large"
                  [type]="showOldPasswordAsText ? 'text' : 'password'"
                  [nzStatus]="
                    forgotPasswordConfirmForm.controls['oldPassword'] | formError
                  "
                />
              </nz-input-group>
              <app-ae-form-error
                [field]="forgotPasswordConfirmForm.controls['oldPassword']"
              ></app-ae-form-error>
            </div>
          }
          <div class="flex flex-col mb-12">
            <label class="title-s cl-on-background mb-8" for="confirm_pass">{{
                'NEW_PASSWORD' | translate
              }}</label>
            <nz-input-group
              [nzPrefix]="passwordPrefix"
              [nzSuffix]="passwordPostfix"
            >
              <input
                id="new_pass"
                formControlName="password"
                nz-input
                nzSize="large"
                [type]="showPasswordAsText ? 'text' : 'password'"
                [nzStatus]="
                    forgotPasswordConfirmForm.controls['password'] | formError
                  "
              />
            </nz-input-group>
            <app-ae-form-error
              [field]="forgotPasswordConfirmForm.controls['password']"
            ></app-ae-form-error>
          </div>

          <div class="flex flex-col mb-24">
            <label class="title-s cl-on-background mb-8" for="confirm_pass">{{
                'CONFIRM_YOUR_PASSWORD' | translate
              }}</label>
            <nz-input-group
              [nzPrefix]="passwordPrefix"
              [nzSuffix]="confirmPasswordPostfix"
            >
              <input
                id="confirm_pass"
                formControlName="confirmPassword"
                nz-input
                nzSize="large"
                [type]="showConfirmPasswordAsText ? 'text' : 'password'"
                [nzStatus]="
                    forgotPasswordConfirmForm.controls['confirmPassword']
                      | formError
                  "
              />
            </nz-input-group>
            <app-ae-form-error
              [field]="forgotPasswordConfirmForm.controls['confirmPassword']"
            ></app-ae-form-error>
          </div>

          <app-ae-button
            class="mb-24"
            buttonType="primary"
            fullWidth
          >
            {{ 'RESET_PASSWORD' | translate }}
          </app-ae-button>
        </div>

        <div class="label-s mb-8">
          {{ 'PASSWORD_MUST_HAVE' | translate }}
        </div>

        <app-password-strength
          [password]="forgotPasswordConfirmForm.value.password!"
          [hideLine]="true"
        ></app-password-strength>
      }
      @case (ForgetPassword.RESET_DONE) {
        <div class="title-l mb-8 txt-green">
          <nz-icon nzType="check-circle" nzTheme="outline" />
          {{ 'ALL_DONE' | translate }}
        </div>
        <div class="body-b mb-24 txt-green">
          {{ 'PASSWORD_CHANGED' | translate }}
        </div>
        <app-ae-button
          class="mb-32"
          buttonType="primary"
          fullWidth
          routerLink="/auth"
        >
          {{ 'BACK_TO_LOGIN' | translate }}
        </app-ae-button>
      }
    }
  </form>
</div>
<ng-template #passwordPrefix>
  <app-ae-icons icon="security-user" [width]="20" [height]="20"></app-ae-icons>
</ng-template>

<ng-template #passwordPostfix>
  @if (!showPasswordAsText) {
    <app-ae-icons
      class="show-hide-password"
      icon="hide"
      [width]="20"
      [height]="20"
      (click)="showPasswordAsText = true"
    ></app-ae-icons>
  } @else {
    <app-ae-icons
      class="show-hide-password"
      icon="show"
      [width]="20"
      [height]="20"
      (click)="showPasswordAsText = false"
    ></app-ae-icons>
  }
</ng-template>

<ng-template #confirmPasswordPostfix>
  @if (!showConfirmPasswordAsText) {
    <app-ae-icons
      class="show-hide-password"
      icon="hide"
      [width]="20"
      [height]="20"
      (click)="showConfirmPasswordAsText = true"
    ></app-ae-icons>
  } @else {
    <app-ae-icons
      class="show-hide-password"
      icon="show"
      [width]="20"
      [height]="20"
      (click)="showConfirmPasswordAsText = false"
    ></app-ae-icons>
  }
</ng-template>

<ng-template #oldPassword>
  @if (!showOldPasswordAsText) {
    <app-ae-icons
      class="show-hide-password"
      icon="hide"
      [width]="20"
      [height]="20"
      (click)="showOldPasswordAsText = true"
    ></app-ae-icons>
  } @else {
    <app-ae-icons
      class="show-hide-password"
      icon="show"
      [width]="20"
      [height]="20"
      (click)="showOldPasswordAsText = false"
    ></app-ae-icons>
  }
</ng-template>
